module.exports = __webpack_public_path__ + "static/media/icon_schedule_film_blue.1f6f9d3f.svg";